import { ModalityLabel } from '@dynamika-shared/types/imagingLabels';
import { CommonInventoryType } from '@dynamika-shared/types/inventory';
import { Option } from '@utils/generateOptions';

type OptionType = Option & CommonInventoryType;

export type GroupOption = { label: string; options: OptionType[] };

const convertLabelsToOptions = (
  labels: CommonInventoryType[],
  alreadyExistNames: string[]
) => {
  return labels.reduce<OptionType[]>((acc, { name, id, dataType }) => {
    if (!alreadyExistNames.includes(name)) {
      acc.push({ name, id, value: id, label: name, dataType } as OptionType);
    }
    return acc;
  }, []);
};

export const transformModalityLabel = (
  allGroupLabels: ModalityLabel[],
  existedGroupLabels: ModalityLabel[]
) => {
  const alreadyExistNames: string[] = existedGroupLabels.flatMap(gr =>
    gr.labels.map(l => l.name)
  );
  return allGroupLabels.reduce<GroupOption[]>(
    (groupAcc, { labels, modalityName: label }) => {
      const options = convertLabelsToOptions(labels, alreadyExistNames);
      if (options.length) groupAcc.push({ label, options });
      return groupAcc;
    },
    []
  );
};
